import React, { CSSProperties } from "react";

export default function IconOrganization(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				fill={props.color ?? "black"}
				d="M9.5 11c.83 0 1.5.67 1.5 1.5V14H8v-1.5c0-.83.67-1.5 1.5-1.5M14.5 11c.83 0 1.5.67 1.5 1.5V14h-3v-1.5c0-.83.67-1.5 1.5-1.5M9.5 6c.83 0 1.5.67 1.5 1.5V9H8V7.5C8 6.67 8.67 6 9.5 6M14.5 6c.83 0 1.5.67 1.5 1.5V9h-3V7.5c0-.83.67-1.5 1.5-1.5"
			/>
			<path
				fill={props.color ?? "black"}
				fill-rule="evenodd"
				d="M17 2a3 3 0 0 1 3 3v17H4V5a3 3 0 0 1 3-3zM7 4a1 1 0 0 0-1 1v15h4v-2a2 2 0 1 1 4 0v2h4V5a1 1 0 0 0-1-1z"
				clip-rule="evenodd"
			/>
		</svg>
	);
}
